
import React from 'react';
import DynamicEditForm from '../../components/DynamicEditForm/DynamicEditForm.js'; // Import your form component
import {getStoredData} from "../../JsonFiles/fetchData";

const EditNewsPage = () => {
  const fields = getStoredData()?.["11"]?.AdminNews ?? {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/news'; // API URL for fetching/editing product
  const successRedirect = '/AdminNews'; // Where to redirect after a successful update

  return (
    <div>
      <DynamicEditForm
        fields={fields}
        apiUrl={apiUrl}
        successRedirect={successRedirect}
      />
    </div>
  );
};

export default EditNewsPage